
import Import1 from "../../../assets/outline/Import1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Import1Icon({ className, dataTestid = "Import1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Import1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
